import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { Product } from '../../types';
import { ProductGrid } from '../products/ProductGrid';
interface FeaturedProductsProps {
  title: string;
  subtitle?: string;
  products: Product[];
  viewAllLink?: string;
}
export function FeaturedProducts({
  title,
  subtitle,
  products,
  viewAllLink
}: FeaturedProductsProps) {
  return <section className="py-12" aria-labelledby={`${title.toLowerCase().replace(/\s+/g, '-')}-heading`} data-id="element-161">
      <div className="max-w-7xl mx-auto px-4" data-id="element-162">
        <div className="flex items-end justify-between mb-8" data-id="element-163">
          <div data-id="element-164">
            <h2 id={`${title.toLowerCase().replace(/\s+/g, '-')}-heading`} className="text-2xl md:text-3xl font-bold text-gray-900 mb-1" data-id="element-165">
              {title}
            </h2>
            {subtitle && <p className="text-gray-600" data-id="element-166">{subtitle}</p>}
          </div>
          {viewAllLink && <Link to={viewAllLink} className="hidden sm:flex items-center gap-1 text-primary-600 hover:text-primary-700 font-medium transition-colors" data-id="element-167">
              View All
              <ArrowRightIcon className="w-4 h-4" data-id="element-168" />
            </Link>}
        </div>

        <ProductGrid products={products} columns={4} data-id="element-169" />

        {viewAllLink && <div className="mt-6 text-center sm:hidden" data-id="element-170">
            <Link to={viewAllLink} className="inline-flex items-center gap-1 text-primary-600 hover:text-primary-700 font-medium transition-colors" data-id="element-171">
              View All Products
              <ArrowRightIcon className="w-4 h-4" data-id="element-172" />
            </Link>
          </div>}
      </div>
    </section>;
}